var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3,8h18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.87,5.49s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,5.49s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.78,5.49s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,21h-4c-1.11,0-2-.9-2-2V5c0-1.11.89-2,2-2h14c1.1,0,2,.89,2,2v4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,16.15v4.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,21v-4.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17,
    y1: 21,
    x2: 17,
    y2: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.52,21h8.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.52,16.24h0c-.24,0-.47-.06-.68-.16-.75-.38-1.05-1.29-.67-2.04l.66-1.3c.23-.45.69-.74,1.2-.74h5.95c.51,0,.97.28,1.2.74l.66,1.3c.11.21.16.45.16.68,0,.84-.68,1.52-1.52,1.52-.75,0-1.41-.48-1.65-1.18-.01-.02-.03-.04-.05-.05-.05-.02-.11,0-.13.05-.24.71-.9,1.18-1.65,1.18-.75,0-1.41-.48-1.65-1.18-.01-.02-.03-.04-.05-.05-.05-.02-.11,0-.13.05-.24.71-.9,1.18-1.65,1.18"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/Marketplace.354fadfdb84599759c25c9a6e0b6ccea.svg";
export { ForwardRef as ReactComponent };